<template>
    <div>
        <p v-for="phase in phases" :key="phase.key">
            <span class="phase-history-title text-uppercase">{{ phase.title }}</span>
            <v-tooltip bottom max-width="400">
                <template v-slot:activator="{ on, attrs }">
                    <v-icon small :color="'primary'" v-bind="attrs" v-on="on" class="ml-5">mdi-help-circle</v-icon>
                </template>
                <span>{{ phase.tooltip }}</span>
            </v-tooltip>
            <br>
            <span>Valor: <strong>{{ formatValue(phase.amount, currency) }}</strong></span>
            <br>
            <span>Justificativa: <strong>{{ phase.justification || 'N/A' }}</strong></span>
            <v-btn v-if="phase.details" class="ml-5" dense elevation="0" @click="$emit('details', phase.details)">
                <span class="caption font-weight-bold">Ver Mais</span>
                <v-icon small>mdi-arrow-right</v-icon>
            </v-btn>
        </p>
    </div>
</template>

<script>
// Histórico do crédito por fase do QGC (lista pública e área do advogado).
// As fases e os textos vêm prontos do backend; aqui só há a apresentação.
export default {
    props: {
        phases: { type: Array, default: () => [] },
        currency: { type: Number, default: 1 },
    },

    methods: {
        formatValue(value, currency) {
            const currencies = { 1: 'BRL', 2: 'USD', 3: 'EUR' };

            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: currencies[currency] || 'BRL'
            }).format(Number(value || 0));
        },
    }
};
</script>

<style scoped>
.phase-history-title {
    color: var(--v-primary-base);
    font-family: 'Raleway';
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}
</style>
